<script setup lang="ts">

import { PRICES } from '@presentation/Types/Settings';

</script><template>

    <Page>

        <div class="grid grid-cols-12 justify-center items-center gap-16">

            <div class="col-span-5 2xl:col-span-6 scale-[75%] xl:scale-[80%] 2xl:scale-100">
                <table class="
                    uppercase text-xs md:text-sm 2xl:text-base 3xl:text-lg text-center w-full
                    border-collapse rounded-lg ring-4 ring-black/10 shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold text-white">
                            <td class="bg-[#2b85be] ring-1 ring-white rounded-tl-lg p-1 md:p-4 w-1/2">New<br/>Vehicles</td>
                            <td class="bg-[#2b85be] ring-1 ring-white rounded-tr-lg p-1 md:p-4 w-1/2">Used<br/>Vehicles</td>
                        </tr>

                        <tr>
                            <td class="bg-white text-black border-t border-gray-500 p-1 md:p-3 lg:px-8 2xl:px-10 text-xs 3xl:text-sm align-top">
                                <div class="mb-2">
                                    <span class="font-semibold">Includes:</span><br />
                                    New and Demo vehicles
                                </div>
                            </td>

                            <td class="bg-white text-black border-t border-gray-500 border-l border-l-gray-300 p-1 md:p-3 text-xs 3xl:text-sm align-top">
                                <div class="mb-2">
                                    <span class="font-semibold">Includes:</span><br />
                                    Vehicles up to the age of 5 years
                                </div>

                            </td>
                        </tr>

                        <tr>
                            <td colspan="2" class="bg-[#c8ae7f] border border-[#927544] text-black p-1 md:p-3 ">Dealer Wholesale Cost</td>
                        </tr>

                        <tr class="font-bold text-base 2xl:text-lg z-10">
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] p-1 md:p-3">${{ PRICES.Category1.Wholesale.toLocaleString() }}</td>
                            <td class="bg-[#c8ae7f] ring-1 ring-[#927544] p-1 md:p-3">${{ PRICES.Category2.Wholesale.toLocaleString() }}</td>
                        </tr>

                        <tr>
                            <td colspan="2" class="bg-white ring-1 ring-gray-300 p-1 md:p-3 text-black">Recommended Retail Price</td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-emerald-500 text-base 2xl:text-lg">
                            <td class="bg-white ring-1 ring-gray-300 rounded-bl-lg p-1 md:p-3">${{ PRICES.Category3.RRP.toLocaleString() }}</td>
                            <td class="bg-white ring-1 ring-gray-300 rounded-br-lg p-1 md:p-3">${{ PRICES.Category4.RRP.toLocaleString() }}</td>
                        </tr>

                    </tbody>

                </table>

                <div class="mt-3 text-xs 2xl:text-base text-center">&gt; $650 margin on each contract</div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

            <div class="col-span-7 2xl:col-span-6 scale-[80%] lg:scale-[90%] 2xl:scale-100 left-10">
                   
                <h1 class="text-xl 2xl:text-2xl font-semibold mb-6">Stand Out Features</h1>
                <ul class="list-disc flex flex-col gap-4 text-lg 2xl:text-xl">
                    <li>
                        Available for <span class="text-[#2b85be] font-semibold">NEW</span>, <span class="text-[#2b85be] font-semibold">USED</span> and <span class="text-[#2b85be] font-semibold">DEMO</span> vehicles
                    </li>
                    <li>
                        Compliments the OEM Warranty
                    </li>
                    <li>
                        Compliments OEM Capped Price Service plans
                    </li>
                    <li>
                        <span class="text-[#2b85be] font-semibold">No setup or ongoing fees</span>, pure profit to the dealership
                    </li>
                    <li>
                        <span class="text-[#2b85be] font-semibold">$650 upfront margin</span>, plus ongoing revenue from the repairs
                    </li>
                </ul>

            </div>

        </div>


    </Page>

</template>